<template>
    <RainCoinOverlay v-if="show && showPopIndex === 0" />
    <van-popup v-model:show="show" position="center" :overlay-style="{ overflow: 'hidden' }" :style="{
        minWidth: '100%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
        zIndex: '10000'
    }">
        <div :class="show && showPopIndex === 0 ? '' : 'showBlurBackground'">
            <div class="closeICon"><van-icon name="cross" @click="closePopup"
                    style="padding: 5px; background-color: #f1b54b5e; border-radius: 30px;" /></div>
            <div class="treasureContainer">

                <!-- popup 1 -->
                <div v-if="showPopIndex === 0">
                    <div class="TitleText">{{ userStore?.dailyTreasure.header }}</div>
                    <div class="giftImageContainer">
                        <AnimatedGiftOne />
                        <div class="textBar">{{ userStore?.dailyTreasure.sub_header }}</div>
                    </div>
                    <div class="claimedBtn_1">
                        <div class="btn" @click="goToClaimed">{{ $t('chest.open') }}</div>
                    </div>
                </div>


                <!-- Popup 2 -->
                <div v-if="showPopIndex === 1">
                    <div class="giftImageContainer">
                        <AnimatedGifttwo />
                    </div>
                    <div class="dataContent">
                        <div class="title1">{{ $t('chest.ReceiveBonus') }}</div>
                        <div class="rewardText">+R$ {{ rewardAmount }}</div>
                        <div class="claimedBtn">
                            <div class="btn" style="margin-top: 45%;" @click="getClaimedInfo">{{ $t('chest.Receive') }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Popup 3 -->
                <div v-if="showPopIndex === 2">
                    <div class="rewardDetails">
                        <img src="@/assets/theme/backbonus_multiple_bg.png" alt="">
                    </div>
                    <div class="content">
                        <div class="contentTitle">{{ $t('chest.multiRewards') }}</div>
                        <div class="contentText" v-for="i in description" :key="i">
                            {{ i }}
                        </div>
                        <div v-if="rewardType == 2" class="multipleTabel">
                            <van-row v-for=" (item,index) in fixedRechargeConfigs" :key="index" class="timesRow">
                                 <van-col span="12">{{ item.amount }}</van-col>
                                <van-col span="12">{{ item.multiple }}X</van-col>
                            </van-row>
                        </div>
                        <div v-else>
                            <div class="bonusText">{{ rewardTimes + 'x' }}</div>
                            <div class="bonusText2">{{ $t('chest.timesBonus') }}</div>
                        </div>
                    </div>
                    <van-row style="padding: 0 15px;">
                        <van-col span="12" style="padding: 0 10px;">
                            <div class="cancelBtn" @click="getClaim">{{ $t('chest.keepClaming') }}</div>
                        </van-col>
                        <van-col span="12" style="padding: 0 10px;">
                            <div class="depositBtn" @click="goToDeposit">{{ $t('chest.claimDoubleBonus') }}</div>
                        </van-col>
                    </van-row>
                </div>
                <LoadingScreen ref="loadingRef" />
                <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
            </div>
        </div>

    </van-popup>
</template>

<script setup lang="ts">
import { defineExpose, ref, defineEmits, onMounted } from 'vue';
import AnimatedGifttwo from './components/animatedGifttwo.vue';
import AnimatedGiftOne from './components/animatedGiftOne.vue';
import RainCoinOverlay from '@/components/common/rainCoinOverlay.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { useUserStore } from '@/stores/user';
import { useRouter } from 'vue-router';
import { useTreasureService } from '@/view/dailyTreasure/supportScript';
const userStore = useUserStore()
const router = useRouter()
const show = ref(false)
const showPopIndex = ref(0)
const isSuccess = ref(false)
const toastContent = ref('')
const statusRef = ref()
const loadingRef = ref()
const rewardAmount = ref(0)
const rewardTimes = ref(0)
const configId = ref('')
const rewardType = ref(1)
const fixedRechargeConfigs = ref<any>([])
const description = ref(JSON.parse(userStore.dailyTreasure?.description || "{}"))

const showError = (msg: string) => {
    toastContent.value = msg
    isSuccess.value = false
    statusRef.value.open()
}
const showSuccess = (msg: string) => {
    toastContent.value = msg
    isSuccess.value = true
    statusRef.value.open()
}

const { fetchRewardInfo, claimReward } = useTreasureService(showError, showSuccess, loadingRef)
const emits = defineEmits(['getClaim', 'resetShowTreasurePopup'])
const goToClaimed = () => {

    getClaimReward()
}
const getClaimedInfo = () => {
    showPopIndex.value = 2
}
const openPopup = () => {
    show.value = true
}
const closePopup = () => {
    show.value = false
    localStorage.setItem('redirectFromCalim', '')
    emits('resetShowTreasurePopup')
}
const goToDeposit = () => {
    router.push({
        path: '/sd-topup',
        query: { cId: configId.value, type: 1 }
    })
}

const getClaimReward = async () => {
    const data = await fetchRewardInfo()
    rewardAmount.value = data.rewardAmount
    rewardTimes.value = data.rewardTimes
    configId.value = data.configId
    showPopIndex.value = 1
    rewardType.value = data.rewardType
    fixedRechargeConfigs.value = data.fixedRechargeConfigs
}

const getClaim = async () => {
    await claimReward()
    setTimeout(() => closePopup(), 1500)
}
onMounted(() => {
    let timeSet = localStorage.getItem('redirectFromCalim')
    if (timeSet === 'true') {
        show.value = true
    } else {
        setTimeout(() => {
            show.value = true
        }, 3000)
    }

})
defineExpose({
    closePopup
})
</script>

<style scoped>
.showBlurBackground {
    backdrop-filter: blur(.26667rem);
    background: #000000a3;
}

.treasureContainer {
    width: 100%;
    height: 100vh;
    align-items: center;
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    padding-bottom: 25px;
}

.closeICon {
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;
    text-align: right;
    font-size: 16px;
    color: #ffffffc7;
}

.van-overlay {
    z-index: 2500 !important;
    backdrop-filter: blur(.26667rem);
}

.van-popup__close-icon {
    color: #000 !important;
}

.giftImageContainer {
    position: relative;
    width: 100%;
}

.rewardDetails {
    position: relative;
    width: 100%;
    display: inline-block;
}

.rewardDetails img {
    width: 100%;
}

.dataContent {
    position: absolute;
    transform: translateY(-100%);
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.title1 {
    color: #FFF8BA;
    text-align: center;
    text-shadow: 2px 0 0 #C54274, 0 2px 0 #C54274, -2px 0 0 #C54274, 0 -2px 0 #C54274, 2px 2px 0 #C54274, -2px 2px 0 #C54274, 2px -2px 0 #C54274, -2px -2px 0 #C54274;
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 900;
}

.rewardText {
    font-size: 45px;
    padding: 10px 0;
    font-weight: bold;
    color: gold;
    text-shadow: 1px 0 0 #000, 0 1px 0 #000, -1px 0 0 #000, 0 -1px 0 #000, 1px 1px 0 #000, -1px 1px 0 #000, 1px -1px 0 #000, -1px -1px 0 #000;
}

.TitleText {
    font-size: 45px;
    padding: 10px 0;
    font-weight: bold;
    color: gold;
    text-shadow: 1px 0 0 #000, 0 1px 0 #000, -1px 0 0 #000, 0 -1px 0 #000, 1px 1px 0 #000, -1px 1px 0 #000, 1px -1px 0 #000, -1px -1px 0 #000;

}

.claimedBtn {
    margin: 0 30%;
}

.claimedBtn_1 {
    position: absolute;
    transform: translateY(-50%);
    left: 30%;
    right: 30%;
}

.btn {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    color: #000000;
    border-radius: 10px;
    font-weight: 700;
    border: none;
    padding: 10px 25px;
    font-size: 18px;
}

.textBar {
    background-color: #00000059;
    color: #e6d1a9;
    font-size: 14px;
    font-weight: bold;
    padding: 15px;
    position: absolute;
    top: 0;
    left: 30px;
    right: 30px;
}

.content {
    position: absolute;
    top: 0;
    left: 15%;
    right: 15%;
    width: 70%;
    height: 92.5%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    pointer-events: none;
}

.contentTitle {
    color: #000;
    font-size: 15px;
    font-weight: bold;
}

.contentText {
    color: #980707;
    font-size: 13px;
}

.bonusText {
    color: #980707;
    font-size: 45px;
    margin-top: 10%;
}

.bonusText2 {
    color: #980707;
    font-size: 15px;
}

.depositBtn {
    color: #000;
    font-size: 15px;
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    border-radius: 30px;
    padding: 5px 20px;
    height: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
}

.cancelBtn {
    font-size: 15px;
    color: #fff;
    background-image: linear-gradient(270deg, rgb(96, 74, 72), rgb(143 143 143) 81%);
    border-radius: 30px;
    padding: 5px 20px;
    height: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
}
.multipleTabel{
    width: 65%;
    font-size: 10px;
    padding-top: 5px;
}
.timesRow{
    padding: 5px;
    background: #912a00;
}

@media (max-width: 380px) {
    .contentTitle {
        font-size: 14px;
    }

    .contentText {
        font-size: 11px;
    }

    .bonusText {
        font-size: 40px;
    }

    .bonusText2 {
        font-size: 12px;
    }

    .depositBtn {
        font-size: 12px;
    }

    .cancelBtn {
        font-size: 12px;
    }
}

@media (max-width: 300px) {
    .content {
        height: 92%;
    }

    .contentTitle {
        font-size: 4vw;
    }

    .contentText {
        font-size: 3vw;
    }

    .bonusText {
        font-size: 10vw;
    }

    .bonusText2 {
        font-size: 3vw;
    }

    .depositBtn {
        font-size: 3vw;
    }

    .cancelBtn {
        font-size: 3vw;
    }
}
</style>
